import React from "react";

import Medialive from "./Medialive.js";
import Instances from "./Instances.js";

function Resource({ eventId, environment, theme }) {
    return (
        <div className="space-y-4 pb-2">
            <Instances eventId={eventId} environment={environment} theme={theme} />
            <Medialive eventId={eventId} environment={environment} theme={theme} />
        </div>
    );
}

export default Resource;
